module.exports = __webpack_public_path__ + "img/book.6c579641.svg";